module.exports = __webpack_public_path__ + "img/20.a4618c04.jpg";